import React from 'react';

import styles from './PaymentPlanFinanceBox.module.scss';
import { sortPricingsByVariant } from '@helpers/sort-pricings-by-variant';
import { usePhrases } from '@hooks/context/usePhrases';
import { useCurrencyFormatter } from '@hooks/useCurrencyFormatter';
import { FinanceDurationPDP } from '../FinanceDurationPDP/FinanceDurationPDP';

export const PaymentPlanFinanceBox = ({
  mainItem,
  financingOfferContent,
  selectedMainProductPricing,
  setSelectedMainProductPricing,
}) => {
  const [theLowestPricing] = sortPricingsByVariant(mainItem.pricings).sort(
    (a, b) => a.recurringAmount - b.recurringAmount
  );

  const unitsTranslations = usePhrases({ name: 'units', rawObject: true });
  const { from, priceBase } = usePhrases({ name: 'general' });
  const { currencyFormatter } = useCurrencyFormatter();

  return (
    <>
      <div className={styles.separator}></div>
      {theLowestPricing.isReferenceAmountActive && (
        <div className={styles.referencePrice}>
          {`${from} ${currencyFormatter({ price: theLowestPricing.referenceRecurringAmount })} / ${unitsTranslations?.month?.value}*`}
        </div>
      )}

      <div className={styles.price}>
        {`${from} ${currencyFormatter({ price: theLowestPricing.recurringAmount })} / ${unitsTranslations?.month?.value}*`}
      </div>
      <div className={styles.description}>{priceBase}</div>

      <FinanceDurationPDP
        title={financingOfferContent?.contractDuartionSelectionTitle}
        selectedFinancePricing={selectedMainProductPricing}
        handlePricingChange={setSelectedMainProductPricing}
        info={financingOfferContent?.contractDuartionSelectionInfoLine}
        partner={financingOfferContent?.contractDuartionSelectionPartnerLine}
        icon={financingOfferContent?.contractDuartionSelectionPartnerIcon}
      />
    </>
  );
};
